import _ from 'underscore';

// return first truthy result
export const fetchResultFromProcessors = ({ processors, options = {} } = {}) => {
  for (let i = 0; i < _.size(processors); i += 1) {
    const result = processors[i](options);

    if (result) {
      return result;
    }
  }

  return '';
};
